/*
 * Render product option selectors
 */ import { h } from 'preact';
import { useCallback, useErrorBoundary, useEffect, useReducer, useState } from 'preact/hooks';
import { selectVariantReducer } from './modules/select-variant';
import { ProductOptionsAsRadioButtons } from './modules/as-radios';
import { ProductOptionsAsDropdown } from './modules/as-dropdown';
import { filterProductOptions } from './modules/filter-options';
import { updateAddressBar } from './modules/update-address-bar';
import { isStringOrNull } from '../typescript/is-string';
const isStoredOptionValidForCurrentProduct = (option, productTags, optionsWithValues)=>{
    if (typeof option !== 'string') {
        return false;
    }
    if (productTags.includes(`hide-${option.toLowerCase()}`)) {
        return false;
    }
    return optionsWithValues.some((optionWithValues)=>optionWithValues.values.includes(option));
};
export const App = function({ product , optionsWithValues , selectCallback , selectedVariantId: rawSelectedVariantId , settings , productTags , sale  }) {
    const [error] = useErrorBoundary(function(err) {
        console.error(err);
    });
    const { id: productId , options: optionNames , variants  } = product;
    const rawStoredOptions = sessionStorage.getItem('selectedOptions');
    const _storedOptions = rawStoredOptions ? JSON.parse(rawStoredOptions) : [];
    const storedOptions = Array.isArray(_storedOptions) && _storedOptions.every(isStringOrNull) ? [
        isStoredOptionValidForCurrentProduct(_storedOptions[0], productTags, optionsWithValues) && _storedOptions[0] || null,
        isStoredOptionValidForCurrentProduct(_storedOptions[1], productTags, optionsWithValues) && _storedOptions[1] || null,
        isStoredOptionValidForCurrentProduct(_storedOptions[2], productTags, optionsWithValues) && _storedOptions[2] || null
    ] : [
        null,
        null,
        null
    ];
    const matchingVariant = variants.find((variant)=>variant.option1 === storedOptions[0] && variant.option2 === storedOptions[1] && variant.option3 === storedOptions[2]);
    const initialSelectedVariant = matchingVariant ? matchingVariant : variants.find((variant)=>variant.id === rawSelectedVariantId) || variants[0];
    var _initialSelectedVariant_id, _initialSelectedVariant_options_;
    const [state, dispatch] = useReducer(selectVariantReducer, {
        optionsWithValues,
        variants,
        selectedVariantId: (_initialSelectedVariant_id = initialSelectedVariant === null || initialSelectedVariant === void 0 ? void 0 : initialSelectedVariant.id) !== null && _initialSelectedVariant_id !== void 0 ? _initialSelectedVariant_id : null,
        selectedOptionIndex: 0,
        selectedOptionValue: (_initialSelectedVariant_options_ = initialSelectedVariant === null || initialSelectedVariant === void 0 ? void 0 : initialSelectedVariant.options[0]) !== null && _initialSelectedVariant_options_ !== void 0 ? _initialSelectedVariant_options_ : null
    });
    const { selectedVariantId , selectedOptionIndex  } = state;
    const [focusedOptionIndex, setFocusedOptionIndex] = useState(selectedOptionIndex);
    const focusOnIndex = useCallback(function(index) {
        setFocusedOptionIndex(index);
    }, [
        setFocusedOptionIndex
    ]);
    const selectedVariant = variants.find(function(variant) {
        return variant.id === selectedVariantId;
    }) || null;
    useEffect(()=>{
        if (!selectedVariant) {
            return;
        }
        updateAddressBar({
            productHandle: product.handle,
            variantId: selectedVariant.id
        });
        selectCallback({
            product,
            selectedVariant
        });
    }, [
        product,
        selectCallback,
        selectedVariant
    ]);
    const optionValueGroups = filterProductOptions({
        optionNames,
        selectedOptions: (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.options) || [],
        variants,
        ignoreSelectedOptions: true
    });
    if (error) {
        return h('div', {}, 'Internal error');
    }
    return h('div', {
        className: 'ProductForm-options'
    }, selectedVariantId && h('input', {
        name: 'id',
        type: 'hidden',
        value: selectedVariantId,
        'data-product-id': product.id
    }), settings.renderStyle === 'radios' ? h(ProductOptionsAsRadioButtons, {
        optionNames,
        optionValueGroups,
        dispatch,
        focusedOptionIndex,
        focusOnIndex,
        selectedVariant,
        variants,
        selectedOptions: storedOptions,
        sale
    }) : h(ProductOptionsAsDropdown, {
        optionNames,
        optionValueGroups,
        dispatch,
        focusedOptionIndex,
        focusOnIndex,
        productId
    }));
};
